<template>
  <div>
    <div class="custom_5">
        {{text}}
    </div>
   
  </div>
</template>
<script>
export default {
  props: {
    payload: {
      type: Object,
      required: true
    }

  },
    data(){
        return {
            text:""
        }
    },
    methods:{




    },
    mounted(){
      // console.log(this.payload)
      this.text = JSON.parse(this.payload.data).data||{}
     console.log(this.text)
       

        
    }

};
</script>
<style lang="scss" scoped>
.custom_5 {

}
</style>